import api from './api';
import { InvestmentSheetCrv, InvestmentSheetPh, InvestmentSheetCra } from '../types/InvestmentSheet';

// CRV Investment Sheet Service
export const investmentSheetCrvService = {
  getAll: () => api.get<InvestmentSheetCrv[]>('/investment-sheets/crv'),
  getById: (id: string) => api.get<InvestmentSheetCrv>(`/investment-sheets/crv/${id}`),
  create: (data: Partial<InvestmentSheetCrv>) => api.post<InvestmentSheetCrv>('/investment-sheets/crv', data),
  update: (id: string, data: Partial<InvestmentSheetCrv>) => api.put<InvestmentSheetCrv>(`/investment-sheets/crv/${id}`, data),
  delete: (id: string) => api.delete(`/investment-sheets/crv/${id}`),
};

// PH Investment Sheet Service
export const investmentSheetPhService = {
  getAll: () => api.get<InvestmentSheetPh[]>('/investment-sheets/ph'),
  getById: (id: string) => api.get<InvestmentSheetPh>(`/investment-sheets/ph/${id}`),
  create: (data: Partial<InvestmentSheetPh>) => api.post<InvestmentSheetPh>('/investment-sheets/ph', data),
  update: (id: string, data: Partial<InvestmentSheetPh>) => api.put<InvestmentSheetPh>(`/investment-sheets/ph/${id}`, data),
  delete: (id: string) => api.delete(`/investment-sheets/ph/${id}`),
};

// CRA Investment Sheet Service
export const investmentSheetCraService = {
  getAll: () => api.get<InvestmentSheetCra[]>('/investment-sheets/cra'),
  getById: (id: string) => api.get<InvestmentSheetCra>(`/investment-sheets/cra/${id}`),
  create: (data: Partial<InvestmentSheetCra>) => api.post<InvestmentSheetCra>('/investment-sheets/cra', data),
  update: (id: string, data: Partial<InvestmentSheetCra>) => api.put<InvestmentSheetCra>(`/investment-sheets/cra/${id}`, data),
  delete: (id: string) => api.delete(`/investment-sheets/cra/${id}`),
  getTicketInfo: (id: string) =>
    api.get<{ valorTicket: number; importe: number; numTicketsCalculated: number; exact: boolean; ticketsLibres: number }>(
      `/investment-sheets/cra/${id}/ticket-info`
    ),
  assignTickets: (id: string, numTickets: number) =>
    api.post<InvestmentSheetCra>(`/investment-sheets/cra/${id}/assign-tickets`, { numTickets }),
};

// Service to get all investment sheets for an investor
export const investmentSheetService = {
  getByInvestor: (investorId: string) => {
    return Promise.all([
      investmentSheetCrvService.getAll(),
      investmentSheetPhService.getAll(),
      investmentSheetCraService.getAll(),
    ]).then(([crvResponse, phResponse, craResponse]) => {
      const crvSheets = crvResponse.data.filter(sheet => sheet.investorId === investorId).map(s => ({ ...s, sheetType: 'CRV' as const }));
      const phSheets = phResponse.data.filter(sheet => sheet.investorId === investorId).map(s => ({ ...s, sheetType: 'PH' as const }));
      const craSheets = craResponse.data.filter(sheet => sheet.investorId === investorId).map(s => ({ ...s, sheetType: 'CRA' as const }));
      return { data: [...crvSheets, ...phSheets, ...craSheets] };
    });
  },
};
